import React, { useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AOS from 'aos';
import 'aos/dist/aos.css';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import Diversity3Icon from '@mui/icons-material/Diversity3';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  background: 'rgba(255, 255, 255, 0.95)',
  borderRadius: theme.spacing(2),
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: theme.shadows[10],
  },
}));

const DevelopmentPartnershipsAndMarginalizedGroups = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Box sx={{ mt: 10, pb: 10 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            textAlign: 'center',
            mb: 6,
            color: '#1E88E5',
          }}
        >
          Development Partnerships & Supporting Marginalized Groups
        </Typography>

        <Grid container spacing={6}>
          {/* Development Partnerships */}
          <Grid item xs={12} md={6}>
            <div data-aos="fade-up">
              <StyledCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <VolunteerActivismIcon
                      color="primary"
                      sx={{ fontSize: 40, mr: 1 }}
                    />
                    <Typography variant="h5" fontWeight={600}>
                      Development Partnerships
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    Advancing a true development partnership between CSOs and
                    other development actors:
                    <ul>
                      <li>The Government</li>
                      <li>Donor Partners</li>
                      <li>The Private Sector Organizations</li>
                      <li>Faith-based/Religious Organizations</li>
                      <li>Indigenous Social Structures like Abba Gadaas and Haadha Siiqqees</li>
                      <li>The Media</li>
                    </ul>
                  </Typography>
                </CardContent>
              </StyledCard>
            </div>
          </Grid>

          {/* Supporting Marginalized Groups */}
          <Grid item xs={12} md={6}>
            <div data-aos="fade-up" data-aos-delay="200">
              <StyledCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Diversity3Icon
                      color="primary"
                      sx={{ fontSize: 40, mr: 1 }}
                    />
                    <Typography variant="h5" fontWeight={600}>
                      Supporting Marginalized Groups
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    Voicing for the voiceless and the marginalized sections of the population:
                    <ul>
                      <li>Poor women and men</li>
                      <li>Women suffering from gender inequalities</li>
                      <li>Destitute and neglected children</li>
                      <li>The elderly</li>
                      <li>Unemployed youth</li>
                      <li>People with physical disabilities</li>
                      <li>Ethnic minorities</li>
                      <li>Internally displaced people</li>
                      <li>Refugees</li>
                    </ul>
                  </Typography>
                </CardContent>
              </StyledCard>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default DevelopmentPartnershipsAndMarginalizedGroups;
